import { FilterItem } from "../filters";

export enum ManagerUserRole {
  VIEWER = 1,
  OPERATOR = 2,
  ADMIN = 3,
}

export enum ManagerUserStatus {
  INACTIVE = 0,
  ACTIVE = 1,
}

export enum AdminManagementCompanyManagerUserSortField {
  NAME = "name",
  CREATED_AT = "createdAt",
  LAST_LOGIN_AT = "lastLoginAt",
}

export const MANAGER_USER_ROLE_OPTIONS: FilterItem[] = [
  { value: String(ManagerUserRole.ADMIN), label: "Administrador" },
  { value: String(ManagerUserRole.OPERATOR), label: "Operador" },
  { value: String(ManagerUserRole.VIEWER), label: "Visualizador" },
];

export const MANAGER_USER_STATUS_OPTIONS: FilterItem[] = [
  { value: String(ManagerUserStatus.ACTIVE), label: "Ativo" },
  { value: String(ManagerUserStatus.INACTIVE), label: "Inativo" },
];
